import { BaseUserResponse } from "@/redux/users/types";

export enum RecipientType {
  User = "USER",
  UserInvite = "USER_INVITE",
}

export interface DataBlockRequestRecipient {
  email: string;
  type: RecipientType;
}

export interface UserRecipient
  extends Omit<BaseUserResponse, "email">,
    DataBlockRequestRecipient {
  type: RecipientType.User;
}

export interface EmailRecipient extends DataBlockRequestRecipient {
  type: RecipientType.UserInvite;
}

export type Recipient = UserRecipient | EmailRecipient;

export enum UserInviteStatus {
  USER_INVITE = "USER_INVITE",
  USER = "USER",
}

export interface DataBlockRequestEditModalsState {
  open: boolean;
  request?: number;
}
